import { createStore as reduxCreateStore, applyMiddleware } from 'redux'
import rootReducer from '../modules'
// import { composeWithDevTools } from 'remote-redux-devtools'
import logger from 'redux-logger'
const createStore = (preloadedState) =>
  reduxCreateStore(
    rootReducer,
    preloadedState,
    // @ts-ignore
    // composeWithDevTools(applyMiddleware(logger)),
  )

export default createStore
